import { gql } from '@apollo/client'

import {
  GetSubmissionProgress_getSubmissionProgress,
  GetSubmissionProgress,
  GetSubmissionProgressVariables
} from 'src/smart/queries/types/GetSubmissionProgress'

import { SmartQuery } from 'src/smart/SmartQuery'

export const SQ_GET_SUBMISSION_PROGRESS: SmartQuery<
  GetSubmissionProgressVariables,
  GetSubmissionProgress,
  GetSubmissionProgress_getSubmissionProgress
> = {
  query: gql`
    query GetSubmissionProgress($batchId: UUID!) {
      getSubmissionProgress(batchId: $batchId) {
        rowsRemaining
      }
    }
  `,
  extract({ getSubmissionProgress }) {
    return getSubmissionProgress
  }
}
